<script lang="ts">
  import { is } from '@shared/lib/utils';
  import { ThemeToggle } from '@shared/ui/theme';
  import { walletSidebarModel } from '@widgets/wallet-sidebar';
  import { useWallet } from '@do/svelte-web3-manager';
  import { Avatar } from '@shared/ui/avatar';
  import { formatWalletId } from '@shared/lib/utils/string';
  import { Link } from '@shared/ui/link';
  import { BurgerButton } from '@shared/ui/buttons/burger';
  import { page } from '$app/stores';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';
  import { mobileMenuActivity } from '@shared/lib';
  import { NavLink } from '@shared/ui/nav-link';
  import { navigationConfig, getLinkVisibility } from '@entities/navigation';

  const wallet = useWallet();

  let offset = 0;
  let y = 0;
  let lastY = 0;
  let innerWidth = 0;
  let isShowHeader = true;

  function handleScroll(y: number) {
    if (y < 80) {
      isShowHeader = true;

      return;
    }

    const dy = lastY - y;

    lastY = y;

    const shouldShowHeader = !(y < offset || dy < 0);

    if (shouldShowHeader !== isShowHeader) {
      isShowHeader = shouldShowHeader;
    }
  }

  $: handleScroll(y);
  $: image = $page.data.configurations.logo;
  $: hasAuctions = $page.data.institutionAuctionsCount > 0;
  $: hasArtists = $page.data.institutionArtistsCount > 0;
</script>

<header
  class="bg-default-50 dark:bg-store-dark sticky top-0 z-20 w-auto transition-transform duration-1000 {is(
    isShowHeader,
    'translate-y-0',
    '-translate-y-[125%]',
  )}"
>
  <nav class="uw:px-12 mx-auto px-5 text-2xl md:px-8 xl:px-12">
    <ul class="flex h-[64px] items-center justify-between gap-2 md:h-[72px] lg:grid lg:grid-cols-[1fr_auto_1fr]">
      <li class="hidden lg:flex lg:items-center lg:gap-20">
        <ul class="flex items-center gap-9 lg:gap-5 xl:gap-9">
          {#each navigationConfig.navigationLinks as { title, link }}
            {@const isVisible = getLinkVisibility(title, { hasAuctions, hasArtists })}

            {#if isVisible}
              <li>
                <NavLink props="{{ href: link, class: 'font-medium text-base' }}">
                  {title}
                </NavLink>
              </li>
            {/if}
          {/each}
        </ul>
      </li>

      <li class="lg:hidden">
        <BurgerButton on:click="{mobileMenuActivity.toggle}" isActive="{$mobileMenuActivity}" />
      </li>

      <Link props="{{ href: '', class: 'block h-[28px]' }}">
        <DirectusImage
          imageData="{image}"
          alt="{image.title}"
          imgClasses="w-auto h-full object-contain dark:invert"
          attributes="{{
            draggable: false,
          }}"
          pictureSizes="{{ default: '200px' }}"
          presetKeys="{Preset.Thumbnail}"
        />
      </Link>

      <li class="flex items-center gap-10 lg:justify-end">
        <ThemeToggle />

        <button
          on:click="{() => walletSidebarModel.walletSidebarActivity.toggle()}"
          class="hidden text-base font-medium lg:flex lg:items-center lg:gap-3"
        >
          {#if $wallet}
            <p>{formatWalletId($wallet.address)}</p>

            <Avatar wallet="{$wallet.address}" />
          {:else}
            Connect wallet
          {/if}
        </button>
      </li>
    </ul>
  </nav>
</header>

<svelte:window bind:scrollY="{y}" bind:innerWidth />
